module.exports = __webpack_public_path__ + "static/media/YM82_7.d5a6ecbb.jpg";